module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-quote-1.054ee18.jpg";